import { Component, Input, NgZone, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import SwiperCore, { Pagination, EffectFade, Autoplay } from 'swiper/core';

// Enable Swiper Paginate, Fade Effect and Autoplay

SwiperCore.use([Pagination, EffectFade, Autoplay]);

@Component({
    selector: 'app-pb-header-home',
    templateUrl: './pb-header-home.component.html',
    styleUrls: ['./pb-header-home.component.scss']
})
export class PbHeaderHomeComponent implements OnInit {

    @Input() content: any = {};
    @Input() module: any = {};
    padding_top: any = '';
    padding_bottom: any = '';
    items: any = [];
    domainUrl: string = environment.webUrl;
    backgroundImage: string = '';
    slides: any = [];

    constructor(private router: Router, private zone: NgZone) { }

    ngOnInit(): void {

        this.content.forEach(element => {
            var item = {
                content: element.data,
                alignment: this.determineAlignment(element.alignment),
                padding: this.determinePadding(element.padding),
                type: element.item.type
            }

            try {
                item.content = JSON.parse(item.content);
            } catch (err) { }

            if (item.content.image != '') {
                item.content.image = this.domainUrl + '/' + item.content.image;
            }

            if (item.content.image_mobile != '') {
                item.content.image_mobile = this.domainUrl + '/' + item.content.image_mobile;
            }

            if (item.content.visibility == 'YES') {
                this.slides.push(item);
            }
        });

        this.padding_top = this.module.padding_top; // Module Padding
        this.padding_bottom = this.module.padding_bottom;

    }

    /**
     * Alignment is returned as LEFT, CENTER, RIGHT
     * Determine class based on response
     */
    determineAlignment(alignment) {

        if (alignment == 'LEFT') {
            return 'text-left';
        } else if (alignment == 'CENTER') {
            return 'text-center';
        } else if (alignment == 'RIGHT') {
            return 'text-right';
        }

    }

    /**
     * Padding is returned as SMALL, MEDIUM, LARGE, XLARGE
     * Determine pixels based on response
     */
    determinePadding(padding) {

        if (padding == 'SMALL') {
            return '10';
        } else if (padding == 'MEDIUM') {
            return '15';
        } else if (padding == 'LARGE') {
            return '30';
        } else if (padding == 'XLARGE') {
            return '60';
        }

    }

    /**
     * Click on 'Get Started' to navigate to selected course
     * If not course has been selected then navigate to course catalogue
     */
    getStarted() {

        this.zone.run(() => {
            this.router.navigateByUrl('/couse-catalogue');
        });

    }

}
